import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Preloader from "../components/preloader/Preloader";
import StudentsSection from "../components/examinations/students/StudentsSection";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { Row, Col, Container } from 'react-bootstrap'



const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
        state_id
        city_id
        district_id
      }
      educationalClasses {
        id
        class
      }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
        exam_subjects{
                subject_id
              }
      }
      globalBranches {
        id
        branch_name
        state_id
        city_id
        district_id
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects{
        id
        subject
      }
      offlineFeeTypes{
        id
        fee_type
      }
         states {
      state_id
      state_name
    }
    districts {
      id
      district_name
      state_id
    }
    cities {
      id
      district_id
      region_id
      city_name
      timestamp
    }
    }
  }
`;


class Students extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };
  render() {
    if (Cookies.get("token") == undefined) this.props.history.push("/login");
    const globals = this.props.globals;
    const loading1 = globals.loading;
    const error1 = globals.error;


    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }


    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <Preloader />
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            <Container fluid>
              {/* <StudentsSection /> */}


              <div className="content-wrapper mb-2">
                <Container fluid>
                  {loading1 ? (
                    <Container>
                      <Row className="my-3">
                        <Col>
                          <div className="spinner-border text-primary text-center loading-img-center"></div>
                        </Col>
                      </Row>
                    </Container>
                  ) : (
                    <>
                      {
                        (() => {
                          let globalsData = globals.globals;
                          if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
                            let globalBranches = [];

                            globalsData.globalBranches.map((item) => {
                              if (Cookies.get("branch_id") == item.id) {
                                globalBranches.push(item)
                              }
                            });
                            globalsData.globalBranches = globalBranches

                          }

                          return (
                            <>
                              <StudentsSection
                                globals={globalsData}
                              />
                            </>
                          );
                        })()
                      }
                    </>
                  )}
                </Container>
              </div>
            </Container>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

// export default Students;


export default withRouter(
  compose(

    graphql(FETCH_GLOBALS,
      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        }), name: "globals"
      }),
  )
    (Students));
